"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _select = require("../../select");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Option = (0, _styledComponents.default)(_select.SelectOption)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 10px !important;\n  font-size: 14px !important;\n"])));
exports.Option = Option;